<template>
  <div>
    <newsletter-dialog
      :is-visible.sync="newsletterDialog"
      :categories="newsletterCategories"
      :email="newsletterUser.email"
      :name="newsletterUser.name"
      @submit="$emit('open-snackbar', $event)"
    >
    </newsletter-dialog>

    <bugreport-dialog
      :is-visible.sync="bugreportDialog"
      @submit="$emit('open-snackbar', $event)"
    >
    </bugreport-dialog>
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";

export default {
  name: "Widgets",
  data() {
    return {
      initialDataWidgets: window.initialDataWidgets,
      newsletterCategories: [],
      newsletterUser: {
        email: "",
        name: ""
      },
      newsletterDialog: false,
      bugreportDialog: false
    };
  },
  created() {
    if (!isEmpty(this.initialDataWidgets)) {
      const {
        newsletter_categories,
        user_email,
        user_name
      } = this.initialDataWidgets.newsletterinitial;
      this.newsletterCategories = newsletter_categories || [];
      this.newsletterUser.email = user_email || "";
      this.newsletterUser.name = user_name || "";

      this.$store.dispatch("setMess", this.initialDataWidgets.mess);
    }
  }
};
</script>

<style scoped></style>
